import { Controller } from "@hotwired/stimulus";

const RELOAD_AFTER_MS = 60000;

// Backstop for a transcript frame waiting on its finished broadcast: a broadcast missed during a reconnect, or a
// request that stalls, would otherwise leave the spinner until a page reload. Reloads the frame now and then;
// the reloaded frame brings its own copy of this controller only while the transcript is still in progress.
export default class extends Controller {
  static values = { url: String };

  connect() {
    this.timer = setTimeout(() => this.#reloadFrame(), RELOAD_AFTER_MS);
  }

  disconnect() {
    clearTimeout(this.timer);
  }

  #reloadFrame() {
    const frame = this.element.closest("turbo-frame");
    if (!frame) return;

    if (frame.src) {
      frame.reload();
    } else {
      frame.src = this.urlValue;
    }
  }
}
